export default __webpack_public_path__ + "static/media/logo-lixil.5ba39a56.svg";